<template>
    <li>
        <phase-templates
            :project-phases="project_phases"
            :service-levels="service_levels"
            :editable="true"
        />
    </li>
</template>

<script>
import is_setting_page from "./IsSettingPage"
import string_utilities from "../../mixins/StringUtilities"

import PhaseTemplates from "../../ui/PhaseTemplates"

export default {
    mixins: [is_setting_page, string_utilities],
    components: {
        PhaseTemplates
    },
    computed: {
        project_phases () {
            return this.dictionary("project_phase")
        },
        service_levels () {
            return this.dictionary("service_level")
        }
    }
}
</script>
